import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellDesignSizeM from './IconWellDesign_size_m';

const props: CreateIconArguments = {
  l: IconWellDesignSizeM,
  m: IconWellDesignSizeM,
  s: IconWellDesignSizeM,
  xs: IconWellDesignSizeM,
  name: 'IconWellDesign',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
